'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dRoles$0024$002dSingle$002dRole from "./presto.types$-Roles$-Single-Role.js";
var $p;
/** @constructor */
function $c_Lpresto_types$Roles$given\uff3fConversion\uff3fString\uff3fRequiredRole$() {
}
export { $c_Lpresto_types$Roles$given\uff3fConversion\uff3fString\uff3fRequiredRole$ as $c_Lpresto_types$Roles$given\uff3fConversion\uff3fString\uff3fRequiredRole$ };
$p = $c_Lpresto_types$Roles$given\uff3fConversion\uff3fString\uff3fRequiredRole$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_s_Conversion();
$p.constructor = $c_Lpresto_types$Roles$given\uff3fConversion\uff3fString\uff3fRequiredRole$;
/** @constructor */
function $h_Lpresto_types$Roles$given\uff3fConversion\uff3fString\uff3fRequiredRole$() {
}
export { $h_Lpresto_types$Roles$given\uff3fConversion\uff3fString\uff3fRequiredRole$ as $h_Lpresto_types$Roles$given\uff3fConversion\uff3fString\uff3fRequiredRole$ };
$h_Lpresto_types$Roles$given\uff3fConversion\uff3fString\uff3fRequiredRole$.prototype = $p;
$p.ns = (function(code) {
  return new $j_presto$002etypes$0024$002dRoles$0024$002dSingle$002dRole.$c_Lpresto_types$Roles$SingleRole(code);
});
$p.v = (function(x) {
  return this.ns(x);
});
var $d_Lpresto_types$Roles$given\uff3fConversion\uff3fString\uff3fRequiredRole$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Roles$given\uff3fConversion\uff3fString\uff3fRequiredRole$, "presto.types$Roles$given_Conversion_String_RequiredRole$", ({
  a17: 1,
  cz: 1,
  t: 1
}));
export { $d_Lpresto_types$Roles$given\uff3fConversion\uff3fString\uff3fRequiredRole$ as $d_Lpresto_types$Roles$given\uff3fConversion\uff3fString\uff3fRequiredRole$ };
var $n_Lpresto_types$Roles$given\uff3fConversion\uff3fString\uff3fRequiredRole$;
function $m_Lpresto_types$Roles$given\uff3fConversion\uff3fString\uff3fRequiredRole$() {
  if ((!$n_Lpresto_types$Roles$given\uff3fConversion\uff3fString\uff3fRequiredRole$)) {
    $n_Lpresto_types$Roles$given\uff3fConversion\uff3fString\uff3fRequiredRole$ = new $c_Lpresto_types$Roles$given\uff3fConversion\uff3fString\uff3fRequiredRole$();
  }
  return $n_Lpresto_types$Roles$given\uff3fConversion\uff3fString\uff3fRequiredRole$;
}
export { $m_Lpresto_types$Roles$given\uff3fConversion\uff3fString\uff3fRequiredRole$ as $m_Lpresto_types$Roles$given\uff3fConversion\uff3fString\uff3fRequiredRole$ };
//# sourceMappingURL=presto.types$-Roles$given_-Conversion_-String_-Required-Role$.js.map
